import React from 'react';
import ContentLoader from 'react-content-loader';

function InstallmentPanelLoading() {
  return (
    <ContentLoader
      data-testid="installmentPanelLoading"
      speed={2}
      width={375}
      height={64}
      viewBox="0 0 375 64"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="16" y="16" rx="2" ry="2" width="32" height="32" />
      <rect x="64" y="23" rx="2" ry="2" width="263" height="18" />
      <rect x="343" y="24" rx="2" ry="2" width="16" height="16" />
    </ContentLoader>
  );
}

export default InstallmentPanelLoading;
